import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheApi, AssistitiApi, EntiApi, OperatoriApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useDeambulazioneTipiDataSource() {
    const api = new AnagraficheApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getDeambulazioneTipi({ tenantId: currentTenant.Id });
          },
    
          byKey: (key) => {
            return api.getDeambulazioneTipoById({
                tenantId: currentTenant.Id,
                deambulazioneTipoId: key
            });
          },
    
          insert: (values) => {
            return api.insertDeambulazioneTipo({
                tenantId: currentTenant.Id,
                deambulazioneTipoCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateDeambulazioneTipo({
                tenantId: currentTenant.Id,
                deambulazioneTipoId: key,
                deambulazioneTipoUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteDeambulazioneTipo({
                tenantId: currentTenant.Id,
                deambulazioneTipoId: key    
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


